import { mapState, mapActions } from "vuex"

export default {
  name: 'nav-button-toggle',
  computed: {
    ...mapState('global', ['sidebarOpened']),
    scope() {
      return {
        toggleSidebar: this.toggleSidebar,
        sidebarOpened: this.sidebarOpened
      }
    }
  },
  methods: {
    ...mapActions('global', ['toggleSidebar']),
  },
  render() {
    return this.$scopedSlots.default(this.scope)
  },
  mounted() {
    this.$root.$emit('nav-button-toggle-mounted')
  }
}
